/** @file Shown for any path the router does not know; the header still offers Projects and Settings. */
import { useT } from '../shell/i18n/useT';
import { ShellHeader } from '../shell/ShellHeader';

/** Rendered by Screen for `{ name: 'notFound' }`. */
export function NotFoundScreen() {
  const t = useT();
  return (
    <main className="shell-page">
      <ShellHeader t={t} title={t('shell.notFound')} />
    </main>
  );
}
